import { Blocks, Building2, CalendarCheck2, ContactRound, Gift, Globe2, Headset, LayoutGrid, Mail, MoonStar, Phone, UsersRound, Zap, type LucideIcon } from "lucide-react";
import whatsAppLogo from "../../assets/flow/channel-whatsapp-official.svg";
// Google Calendar product mark, sourced from workspace.google.com/products/calendar/.
// https://www.gstatic.com/images/branding/productlogos/calendar_2026/v2/web/192px.svg
import googleCalendarLogo from "../../assets/flow/google-calendar-official.svg";

const languageMarks: Record<string, string> = { yue: "粵", mandarin: "普", english: "EN" };
const brandMarks: Record<string, string> = { whatsapp: whatsAppLogo, calendar: googleCalendarLogo };
const optionIcons: Record<string, LucideIcon> = {
  "more-languages": Globe2,
  phone: Phone,
  email: Mail,
  "more-channels": LayoutGrid,
  pms: Building2,
  crm: ContactRound,
  "more-systems": Blocks,
  "always-night": MoonStar,
  "always-weekend": CalendarCheck2,
  "always-busy": Headset,
  "plan-free": Gift,
  "plan-pro": Zap,
  "plan-team": UsersRound,
};

export function HomeOptionIcon({ id }: { id: string }) {
  const languageMark = languageMarks[id];
  const brandMark = brandMarks[id];
  const Icon = optionIcons[id] ?? LayoutGrid;

  return (
    <span className="ce-home-option-mark" data-option-mark={id} aria-hidden="true">
      {brandMark ? <img src={brandMark} alt="" width={22} height={22} draggable={false} />
        : languageMark ? <span className="ce-home-option-letter">{languageMark}</span>
          : <Icon size={18} strokeWidth={1.8} />}
    </span>
  );
}
